<script>
    import { store, store_init_offer } from '../../Store.svelte';
    import Preloader from '../../components/Preloader.svelte';
    import AddressModal from '../../components/common/AddressModal.svelte';
    import PlanTypeSky from '../../components/comparator/PlanTypeSky.svelte';
    import LegalsComponentSky from '../../components/comparator/components/LegalsComponentSky.svelte';

    let sky_prepago = [];
    let sky_pospago = [];
    let isPrepago = true;
    $store.requestedServices.isSky = true;

    const loadData = () => {
        const { loadedOffer } = $store_init_offer;
        const { offers } = loadedOffer;

        sky_prepago = offers.offnet_sky;
    };

    $: if ($store_init_offer.loadedOffer.offers) {
        loadData();
    }

    const toggleSelection = (prepago) => {
        isPrepago = prepago;
    };

    const popupClick = () => {};
</script>

{#if $store_init_offer.loadedOffer == null || $store_init_offer.loadedOffer.offers == null}
    <div class="pure-g full-width">
        <div class="pure-u-1">
            <div class="text-center">
                <h2 class="text-fs-23 fw-semibold base-text m-b-5">
                    Obteniendo paquetes disponibles
                </h2>
                <p class="text-fs-13 m-b-15">
                    {$store.requestedAddress.addressString}
                    {$store.requestedAddress.postalCode}
                </p>
                <p class="text-fs-13">
                    <a
                        href="#/"
                        on:click|preventDefault={popupClick}
                        class="popup base-text underline"
                        data-custom-open="modal-cobertura">Cambiar dirección</a
                    >
                </p>
            </div>
            <div class="pure-g">
                <div class="pure-u-1">
                    <div class="text-center"><Preloader /></div>
                </div>
            </div>
        </div>
    </div>
{:else}
    <div class="comparator-container-sky full-height">
        <p class="home-title">Oferta Sky</p>
        <div class="steps-container">
            <p class="header">Elige, selecciona y configura tu paquete</p>
            <!-- <p class="text">1. Elige el servicio que necesitas</p> -->
        </div>
        <!-- <div class="selector-container">
            {#if sky_prepago.length > 0}
                <div
                    class="selector {isPrepago ? 'selected' : ''}"
                    on:click={() => toggleSelection(true)}
                    on:keydown={() => toggleSelection(true)}
                >
                    <div class="check-icon">
                        {#if isPrepago}
                            <svg class="icon-check">
                                <use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-check"
                                />
                            </svg>
                        {/if}
                    </div>
                    <div class="selector-content">
                        <svg class="icon">
                            <use
                                xlink:href="/assets/img/icons/symbol-defs.svg#icon-tv"
                            />
                        </svg>
                        <p>Sky prepago</p>
                    </div>
                </div>
            {/if}
            {#if sky_pospago.length > 0}
                <div
                    class="selector {!isPrepago ? 'selected' : ''}"
                    on:click={() => toggleSelection(false)}
                    on:keydown={() => toggleSelection(false)}
                >
                    <div class="check-icon">
                        {#if !isPrepago}
                            <svg class="icon-check">
                                <use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-check"
                                />
                            </svg>
                        {/if}
                    </div>
                    <div class="selector-content">
                        <svg class="icon">
                            <use
                                xlink:href="/assets/img/icons/symbol-defs.svg#icon-tv"
                            />
                        </svg>
                        <p>Sky pospago</p>
                    </div>
                </div>
            {/if}
        </div> -->
        <div class="plan-comparator-container-sky">
            {#if sky_prepago.length > 0 && isPrepago}
                {#each sky_prepago as plan}
                    <PlanTypeSky {plan} category="offnet_sky" home />
                {/each}
            {/if}
            {#if sky_pospago.length > 0 && !isPrepago}
                {#each sky_pospago as plan}
                    <PlanTypeSky {plan} category="offnet_sky" home />
                {/each}
            {/if}
        </div>
        <LegalsComponentSky {isPrepago} />
    </div>
{/if}
<div>
    <div class="modal" id="modal-cobertura" aria-hidden="true">
        <AddressModal home={true} />
    </div>
</div>
